import React, { useState } from "react";
import { useTranslation } from "react-i18next";

function SearchBox({ showBarcode, searchResult, placeholder, width, value }) {
  const { t, i18n } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");

  // Responsive width handling
  const widthClass = width
    ? `w-full sm:w-[${width}]`
    : "w-[96%] sm:w-96";

  return (
    <div className={`relative flex items-center ${widthClass} max-w-full`}>
      
      {/* Icon */}
      <div
        className={`absolute inset-y-0 ${
          i18n.language === "ar" ? "right-0 pr-3" : "left-0 pl-3"
        } flex items-center pointer-events-none`}
      >
        <svg
          className="w-4 h-4 text-gray-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 20 20"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
          />
        </svg>
      </div>

      {/* Input */}
      <input
        type="search"
        className={`block h-10 w-full text-sm text-gray-950 font-normal border ${
          i18n.language === "ar"
            ? "pr-10 text-right"
            : "pl-10 text-left"
        } rounded-md border-[#CCCCCC]`}
        style={{ outline: "none" }}
        placeholder={t(placeholder)}
        value={value !== undefined ? value : searchTerm}
        onChange={(event) => {
          setSearchTerm(event.target.value);
          searchResult(event.target.value);
        }}
      />
    </div>
  );
}

export default SearchBox;